import { useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { useClientAuth } from "@/lib/clientAuth";
import { formatApiError } from "@/lib/api";

export default function ClientLogin() {
  const { client, ready, login } = useClientAuth();
  const navigate = useNavigate();
  const [loginId, setLoginId] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  if (ready && client) return <Navigate to="/client-portal" replace />;

  const submit = async (event) => {
    event.preventDefault(); setBusy(true); setError("");
    try { await login(loginId, password); navigate("/client-portal"); }
    catch (err) { setError(formatApiError(err)); }
    finally { setBusy(false); }
  };

  return (
    <main className="min-h-[100dvh] bg-zinc-950 grid lg:grid-cols-[1.05fr_.95fr]">
      <section className="hidden lg:flex relative overflow-hidden p-14 text-white flex-col justify-between">
        <div className="absolute inset-0 opacity-35 bg-[radial-gradient(circle_at_15%_20%,#00aade_0,transparent_35%),radial-gradient(circle_at_85%_25%,#e6007e_0,transparent_32%),radial-gradient(circle_at_60%_90%,#ffd500_0,transparent_30%)]" />
        <img className="relative w-56 bg-white rounded-sm p-3" src="/images/jyoti-image-logo.png" alt="Jyoti Image" />
        <div className="relative max-w-xl">
          <div className="text-xs uppercase tracking-[.3em] text-cyan-300 mb-4">From Plate to Print</div>
          <h1 className="font-heading text-5xl font-bold leading-tight">Your print activity,<br/>clearly presented.</h1>
          <p className="mt-5 text-zinc-300 max-w-lg">Review jobs, plate totals and bill-wise summaries for any period in one secure place.</p>
        </div>
        <div className="relative flex h-2 w-48 overflow-hidden rounded-full"><i className="flex-1 bg-cyan-400"/><i className="flex-1 bg-fuchsia-500"/><i className="flex-1 bg-yellow-400"/><i className="flex-1 bg-zinc-700"/></div>
      </section>
      <section className="bg-white flex items-center justify-center p-6">
        <form onSubmit={submit} className="w-full max-w-md">
          <img className="lg:hidden w-48 mb-10" src="/images/jyoti-image-logo.png" alt="Jyoti Image" />
          <div className="text-xs font-bold uppercase tracking-[.24em] text-fuchsia-600">Client access</div>
          <h2 className="font-heading text-3xl font-bold mt-2">Welcome back</h2>
          <p className="text-sm text-zinc-500 mt-2 mb-8">Sign in with the client ID issued by Jyoti Image.</p>
          <label className="block text-xs font-bold uppercase tracking-wide text-zinc-600 mb-2">Client ID</label>
          <input className="w-full border border-zinc-300 rounded-sm px-4 py-3 mb-4 focus:outline-none focus:ring-2 focus:ring-cyan-400" value={loginId} onChange={e=>setLoginId(e.target.value)} autoComplete="username" required />
          <label className="block text-xs font-bold uppercase tracking-wide text-zinc-600 mb-2">Password</label>
          <input className="w-full border border-zinc-300 rounded-sm px-4 py-3 focus:outline-none focus:ring-2 focus:ring-fuchsia-400" type="password" value={password} onChange={e=>setPassword(e.target.value)} autoComplete="current-password" required />
          {error && <div className="mt-4 p-3 bg-red-50 border border-red-200 text-red-700 text-sm">{error}</div>}
          <button disabled={busy} className="mt-6 w-full bg-zinc-950 text-white py-3 rounded-sm font-bold hover:bg-cyan-600 transition-colors disabled:opacity-50">{busy ? "Signing in…" : "Open my dashboard"}</button>
          <button type="button" onClick={()=>navigate("/")} className="w-full mt-4 text-sm text-zinc-500 hover:text-zinc-950">Return to website</button>
        </form>
      </section>
    </main>
  );
}
